var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPanelCross = function SvgIconPanelCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.96 9.337a.623.623 0 0 1 .08 0l4.844-4.497a.607.607 0 0 1 .814 0 .509.509 0 0 1 0 .757L11.954 10l4.744 4.403a.509.509 0 0 1 0 .757.607.607 0 0 1-.814 0l-4.845-4.497a.643.643 0 0 1-.078 0L6.116 15.16a.607.607 0 0 1-.814 0 .509.509 0 0 1 0-.757L10.046 10 5.302 5.597a.509.509 0 0 1 0-.757c.225-.209.59-.209.814 0l4.845 4.497Z",
    fill: "#000"
  })));
};
export { SvgIconPanelCross as ReactComponent };